import UserManager from './userManager.vue';
import UserList from './views/userList.vue';

export const userManagerRoutes = [
  {
    path: 'userManager',
    component: UserManager,
    children: [
      { path: '', component: UserList, name: 'userList' }
    ]
  }
];
